import type { CardButtonProps } from '@jouzen/ecom-components';

import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

const commonButtonProps: CardButtonProps = {
  ariaLabel: 'press_read_article',
  external: true,
  color: 'brown-500',
  rel: 'noopener noreferrer',
  target: '_blank',
};

const activityAndMovementFooterCards = (
  locale: string,
): ArticleCardDataProps[] => [
  {
    heading: 'acitivy_article_one',
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog/${locale}/staying-active/`,
    },
  },
  {
    heading: 'acitivy_article_two',
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog/${locale}/oura-and-strava-partnership/`,
    },
  },
  {
    heading: 'acitivy_article_three',
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog/${locale}/all-hours-with-oura-jalen-brunson/`,
    },
  },
];

const activityAndMovementFooterImageData = (
  locale: string,
): ArticleImageProps => ({
  alt: 'activity_footer_alt',
  buttonProps: {
    className: 'text-sandstone-500',
    external: true,
    href: `https://ouraring.com/blog/${locale}/activity-score/`,
    label: 'read_more',
    rel: 'noopener noreferrer',
    target: '_blank',
    variant: 'secondary-light',
  },
  heading: 'activity_footer_title',
  src: 'blue-sky/activity-and-movement/footer',
  headingClassname: 'max-w-80',
});

export { activityAndMovementFooterCards, activityAndMovementFooterImageData };
